import React, { useState, lazy } from 'react';
import { ModernHeader } from '../components/ModernHeader';
import { Footer } from '../components/Footer';
import { MapPin, Phone, Mail, Clock, Send, CheckCircle } from 'lucide-react';
export function ContactPage() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    captcha: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formState.captcha) {
      alert('Please complete the captcha verification.');
      return;
    }
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setFormState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        captcha: false
      });
    }, 1500);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormState(prev => ({
      ...prev,
      [name]: value
    }));
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-598">
      <ModernHeader data-id="element-599" />

      {/* Page Header Banner */}
      <section className="bg-gray-800 py-12" data-id="element-600">
        <div className="max-w-7xl mx-auto px-4" data-id="element-601">
          <h1 className="text-3xl md:text-4xl font-bold text-white text-center" data-id="element-602">
            Contact Us
          </h1>
          <p className="text-gray-300 text-center mt-2 max-w-2xl mx-auto" data-id="element-603">
            Have questions about our products or need a custom quote? Our team
            is here to help.
          </p>
        </div>
      </section>

      <main className="py-12 md:py-16" data-id="element-604">
        <div className="max-w-7xl mx-auto px-4" data-id="element-605">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-606">
            {/* Contact Information */}
            <div className="space-y-8" data-id="element-607">
              <div data-id="element-608">
                <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-609">
                  Get in Touch
                </h2>
                <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-610">
                  Whether you need help identifying a part, checking stock
                  availability, or placing a bulk order, our knowledgeable staff
                  is ready to assist you.
                </p>

                <div className="space-y-6" data-id="element-611">
                  <div className="flex items-start gap-4" data-id="element-612">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-613">
                      <Phone className="w-6 h-6 text-blue-700" data-id="element-614" />
                    </div>
                    <div data-id="element-615">
                      <h3 className="font-bold text-gray-900 text-lg" data-id="element-616">Phone</h3>
                      <a href="tel:863-337-4984" className="text-red-700 font-bold text-xl mt-1 block hover:text-red-800 transition-colors" data-id="element-617">
                        863-337-4984
                      </a>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-618">
                        Commercial Sales Only
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-619">
                    <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-620">
                      <Mail className="w-6 h-6 text-red-700" data-id="element-621" />
                    </div>
                    <div data-id="element-622">
                      <h3 className="font-bold text-gray-900 text-lg" data-id="element-623">Email</h3>
                      <a href="mailto:sales@usabearingsandbelts.com" className="text-blue-700 hover:underline text-lg block mt-1" data-id="element-624">
                        sales@usabearingsandbelts.com
                      </a>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-625">
                        We typically respond within 1 business day
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-626">
                    <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-627">
                      <Clock className="w-6 h-6 text-gray-700" data-id="element-628" />
                    </div>
                    <div data-id="element-629">
                      <h3 className="font-bold text-gray-900 text-lg" data-id="element-630">
                        Business Hours
                      </h3>
                      <p className="text-gray-700 mt-1" data-id="element-631">Monday - Friday</p>
                      <p className="text-gray-700" data-id="element-632">9:00 AM - 3:00 PM ET</p>
                      <p className="text-sm text-red-600 mt-1 font-medium" data-id="element-633">
                        Closed on Weekends & National Holidays
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-634">
                    <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-635">
                      <MapPin className="w-6 h-6 text-green-700" data-id="element-636" />
                    </div>
                    <div data-id="element-637">
                      <h3 className="font-bold text-gray-900 text-lg" data-id="element-638">
                        Location
                      </h3>
                      <p className="text-gray-700 mt-1" data-id="element-639">
                        8012 118th Ave N<br data-id="element-640" />
                        Largo, Florida 33773
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Map */}
              <div className="bg-white p-2 rounded-xl shadow-sm border border-gray-200 h-64 lg:h-80 overflow-hidden" data-id="element-641">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3525.867963690688!2d-82.753889!3d27.879722!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2e4e1a0a0a0a1%3A0x1a0a0a0a0a0a0a0a!2s8012%20118th%20Ave%20N%2C%20Largo%2C%20FL%2033773!5e0!3m2!1sen!2sus!4v1620000000000!5m2!1sen!2sus" width="100%" height="100%" style={{
                border: 0
              }} allowFullScreen loading="lazy" title="USA Bearings & Belts Location" data-id="element-642"></iframe>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 md:p-8" data-id="element-643">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-644">
                Send us a Message
              </h2>

              {isSuccess ? <div className="bg-green-50 border border-green-200 rounded-lg p-8 text-center" data-id="element-645">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-646">
                    <CheckCircle className="w-8 h-8 text-green-600" data-id="element-647" />
                  </div>
                  <h3 className="text-xl font-bold text-green-800 mb-2" data-id="element-648">
                    Message Sent!
                  </h3>
                  <p className="text-green-700 mb-6" data-id="element-649">
                    Thank you for contacting us. We have received your message
                    and will get back to you shortly.
                  </p>
                  <button onClick={() => setIsSuccess(false)} className="text-green-700 font-semibold hover:underline" data-id="element-650">
                    Send another message
                  </button>
                </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-651">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-652">
                    <div data-id="element-653">
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-654">
                        Your Name <span className="text-red-500" data-id="element-655">*</span>
                      </label>
                      <input type="text" id="name" name="name" required value={formState.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" placeholder="John Doe" data-id="element-656" />
                    </div>
                    <div data-id="element-657">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-658">
                        Email Address <span className="text-red-500" data-id="element-659">*</span>
                      </label>
                      <input type="email" id="email" name="email" required value={formState.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" placeholder="john@example.com" data-id="element-660" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-661">
                    <div data-id="element-662">
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-663">
                        Phone Number
                      </label>
                      <input type="tel" id="phone" name="phone" value={formState.phone} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" placeholder="(555) 123-4567" data-id="element-664" />
                    </div>
                    <div data-id="element-665">
                      <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-666">
                        Subject <span className="text-red-500" data-id="element-667">*</span>
                      </label>
                      <select id="subject" name="subject" required value={formState.subject} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" data-id="element-668">
                        <option value="" data-id="element-669">Select a subject...</option>
                        <option value="Sales Inquiry" data-id="element-670">Sales Inquiry</option>
                        <option value="Order Status" data-id="element-671">Order Status</option>
                        <option value="Product Support" data-id="element-672">Product Support</option>
                        <option value="Returns" data-id="element-673">Returns / RGA Request</option>
                        <option value="Other" data-id="element-674">Other</option>
                      </select>
                    </div>
                  </div>

                  <div data-id="element-675">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-676">
                      Message <span className="text-red-500" data-id="element-677">*</span>
                    </label>
                    <textarea id="message" name="message" required rows={5} value={formState.message} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all resize-none" placeholder="How can we help you today?" data-id="element-678"></textarea>
                  </div>

                  {/* Custom Captcha UI */}
                  <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 flex items-center gap-4 w-fit" data-id="element-679">
                    <div className="relative flex items-center" data-id="element-680">
                      <input type="checkbox" id="captcha" checked={formState.captcha} onChange={e => setFormState(prev => ({
                    ...prev,
                    captcha: e.target.checked
                  }))} className="w-6 h-6 border-2 border-gray-300 rounded cursor-pointer text-blue-600 focus:ring-blue-500" data-id="element-681" />
                    </div>
                    <label htmlFor="captcha" className="text-sm text-gray-700 cursor-pointer select-none" data-id="element-682">
                      I'm not a robot
                    </label>
                    <div className="ml-4 flex flex-col items-center justify-center" data-id="element-683">
                      <img src="https://www.gstatic.com/recaptcha/api2/logo_48.png" alt="reCAPTCHA" className="w-8 h-8 opacity-50" data-id="element-684" />
                      <span className="text-[10px] text-gray-400" data-id="element-685">
                        reCAPTCHA
                      </span>
                    </div>
                  </div>

                  <button type="submit" disabled={isSubmitting} className={`
                      w-full flex items-center justify-center gap-2 py-3 px-6 rounded-lg font-bold text-white transition-all
                      ${isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-800 hover:bg-blue-900 shadow-md hover:shadow-lg transform hover:-translate-y-0.5'}
                    `} data-id="element-686">
                    {isSubmitting ? <>
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-687"></div>
                        Sending...
                      </> : <>
                        <Send className="w-5 h-5" data-id="element-688" />
                        Send Message
                      </>}
                  </button>

                  <p className="text-xs text-gray-500 text-center mt-4" data-id="element-689">
                    By submitting this form, you agree to our{' '}
                    <a href="/privacy" className="text-blue-600 hover:underline" data-id="element-690">
                      Privacy Policy
                    </a>
                    .
                  </p>
                </form>}
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-691" />
    </div>;
}